<template>
    <div class="middleContent">
      <BreadList :active="$route.params.type" :info="breadList"/>
      <ul class="list">
        <listDemo link="NewsXq" :info="item" v-for="item in listData.list" :key="item.id"/>
      </ul>
      <Pagination @changePage="changePage" :totalPage="listData.totalPage" :pageNumber="listData.pageSize" :current="listData.pageNum"/>
    </div>
</template>

<script>
import Pagination from '../Pagination'
import BreadList from '../BreadLink'
import link from '@/link.js'
import listDemo from '@/components/listDemo'
import api from '@/api/api'
export default {
  name: 'List',
  components:{
    Pagination,
    BreadList,
    listDemo
  },
  data () {
    return {
      listData:[],
      breadList:link[4].list,
    }
  },
  watch:{
    $route(){
      this.getList(1)
    }
  },
  methods:{
    changePage(index){
      this.getList(1);
    },
    getList(pageNum){
      api.getNews({
        pageNum:pageNum,
        pageSize:10,
        subType:this.$route.params.type,
        type:'4'
      }).then(res=>{
        this.listData = res.data.data;
      })
    }
  },
  created(){
    this.getList(1);
  }
}
</script>
<style lang="scss" scoped>
.middleContent{
  padding-bottom: 100px;
    .title{
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 20px;
    line-height: 26px;
    border-bottom: 1px solid #E5E5E5;
    p{
        padding: 20px 0 18px;
        border-bottom: 2px solid transparent;
        cursor: pointer;
    }
    .active{
        border-bottom: 2px solid #FAB51D;
    }
    span{
        color: #C0C4CC;
        margin: 0 16px;
    }
    }
    .list{
      width: 100%;
      margin: 40px 0;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/Encyclopedia/List.vue